import MyUploadsPage from './MyUploadsPage'
export default MyUploadsPage;